import { motion } from "framer-motion";
import { Award } from "lucide-react";

const patents = [
  {
    title: "Brevetto Dispositivi DPI",
    desc: "Dispositivi di protezione individuale innovativi",
    img: "https://images.unsplash.com/photo-1561553413-a42ff936ef93?w=800&q=80",
  },
  {
    title: "Brevetto Giacchetto Antiproiettile",
    desc: "Protezione balistica avanzata e leggera",
    img: "https://images.unsplash.com/photo-1599583863916-e06c29087f51?w=800&q=80",
  },
  {
    title: "Cruscotto Intelligente",
    desc: "Dashboard veicolare con intelligenza artificiale",
    img: "https://images.unsplash.com/photo-1713557112617-e12d67bddc3a?w=800&q=80",
  },
  {
    title: "Sistema Automatico Rilevazione Danni Autoveicoli",
    desc: "Analisi automatizzata dei danni con AI",
    img: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    title: "Fibra Tessuto Arancio",
    desc: "Tessuto tecnico ad alte prestazioni",
    img: "https://images.unsplash.com/photo-1700830151586-d0df2714cb28?w=800&q=80",
  },
  {
    title: "Sonda Laparoscopica Rotante",
    desc: "Strumento chirurgico mini-invasivo brevettato",
    img: "https://images.unsplash.com/photo-1676311563574-8857a67d86df?w=800&q=80",
  },
  {
    title: "Etichetta Intelligente per Alimenti",
    desc: "Monitoraggio smart della freschezza alimentare",
    img: "https://images.pexels.com/photos/373543/pexels-photo-373543.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
];

function PatentCarouselRow({ items, direction = "left", speed = 35 }) {
  const doubled = [...items, ...items];
  return (
    <div className="overflow-hidden">
      <div
        className={direction === "left" ? "animate-carousel-left" : "animate-carousel-right"}
        style={{ animationDuration: `${speed}s` }}
      >
        <div className="flex gap-5" style={{ width: "max-content" }}>
          {doubled.map((patent, i) => (
            <div
              key={i}
              className="group relative w-[340px] sm:w-[420px] flex-shrink-0 border border-white/10 bg-[#121212] hover:border-[#FF3366]/50 transition-all duration-300"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={patent.img}
                  alt={patent.title}
                  className="w-full h-full object-cover transition-all duration-700 grayscale-[60%] group-hover:grayscale-0 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-[#121212]/30 to-transparent" />
                <div className="absolute top-4 left-4">
                  <Award size={20} className="text-[#FF3366]" />
                </div>
              </div>
              <div className="p-5">
                <h4 className="font-heading text-lg font-bold leading-tight">{patent.title}</h4>
                <p className="text-[#A3A3A3] text-sm mt-2 font-body">{patent.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function PatentsSection() {
  const firstRow = patents.slice(0, 4);
  const secondRow = patents.slice(4, 7);

  return (
    <section id="brevetti" data-testid="patents-section" className="py-24 sm:py-32 bg-[#0a0a0a] border-y border-white/5 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <span className="font-mono text-xs tracking-[0.2em] text-[#FF3366] uppercase">BREVETTI & INVENZIONI</span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-tight">
            Siamo i creatori<br />
            <span className="text-[#A3A3A3]">di queste invenzioni</span>
          </h2>
          <p className="text-[#A3A3A3] font-body text-lg mt-6 max-w-2xl">
            Dal settore medico alla sicurezza, dalla tecnologia automotive all'alimentare: le nostre invenzioni brevettate trasformano idee in realta.
          </p>
        </motion.div>
      </div>

      <div className="space-y-5">
        <PatentCarouselRow items={firstRow} direction="left" speed={38} />
        <PatentCarouselRow items={secondRow} direction="right" speed={32} />
      </div>
    </section>
  );
}
